import {useState} from 'react';

import Card from 'components/cards/Card';
// import {Link} from 'react-router-dom';
import Icon from '@material-tailwind/react/Icon';

import Faq from './Faq';
import Legal from './Legal';
import Fees from './Fees';
import ContactUs from './ContactUs';

import {useParams} from 'react-router-dom';

export default function Main() {
    const { section } = useParams();
    const [selected, setSelected] = useState(section ? section : 'faq');

    return (
        <>
            <div className="h-5" />
            <div className="flex">
                <div className="w-1-3 md:w-full" onClick={() => setSelected('faq')}>
                    <Card className={selected === "faq" ? "bg-white shadow-2xl cursor-pointer" : "bg-green-500 shadow-2xl cursor-pointer"}>
                        <div className="flex items-center justify-center flex-col h-full">
                            <Icon name="live_help" color={"black"} size="6xl" />
                            <h3 className={"text-black"}>FAQ</h3>
                        </div>
                    </Card>
                </div>
                <div className="w-1-3 md:w-full ml-3-custom md:ml-5" onClick={() => setSelected('fees')}>
                    <Card className={selected === "fees" ? "bg-white shadow-2xl cursor-pointer" : "bg-green-500 shadow-2xl cursor-pointer"}>
                        <div className="flex items-center justify-center flex-col h-full">
                            <Icon name="paid" color={"black"} size="6xl" />
                            <h3 className={"text-black"}>Fees</h3>
                        </div>
                    </Card>
                </div>
                <div className="w-1-3 md:w-full ml-3-custom md:ml-5" onClick={() => setSelected('legal')}>
                    <Card className={selected === "legal" ? "bg-white shadow-2xl cursor-pointer" : "bg-green-500 shadow-2xl cursor-pointer"}>
                        <div className="flex items-center justify-center flex-col h-full">
                            <Icon name="language" color={"black"} size="6xl" />
                            <h3 className={"text-black"}>Legal</h3>
                        </div>
                    </Card>
                </div>
            </div>
            <div className="h-10" />
            <div className="grid grid-cols-1 xl:grid-cols-6">
                <div className="xl:col-start-1 xl:col-end-5 px-4 mb-5">
                    {selected === 'faq' && <Faq />}
                    {selected === 'fees' && <Fees />}
                    {selected === 'legal' && <Legal />}
                </div>
                <div className="xl:col-start-5 xl:col-end-7 px-4 mb-5">
                    <ContactUs />
                </div>
            </div>
        </>
    );
}
